import createHistory from 'history/createHashHistory';

export default createHistory();



// WEBPACK FOOTER //
// ./src/history.js